var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['section.cmpStructure'] = (function () {
    'use strict';

    const initialize = (section) => {

        const widgets = section.querySelectorAll('.component.cmp--structure');
        if (!widgets || !widgets.length) return;

        widgets.forEach(widget => {
            pageBuilderWidgetRemoveContainer(widget);
            pageBuilderWidgetRemoveTheme(widget);
        });
    };

    // Removes the direct .container child from the widget, preserving its child nodes.
    const pageBuilderWidgetRemoveContainer = (widget) => {
        const container = widget.firstElementChild;
        if (container?.classList.contains('container')) {
            widget.replaceChildren(...container.childNodes);
        }
    };

    // Removes the 'data-theme' attribute from the widget.
    const pageBuilderWidgetRemoveTheme = (widget) => {
        widget.removeAttribute('data-theme');
    };


    return {
        initialize
    };

})();